module.exports = __webpack_public_path__ + "media/bomb.811e4b18.wav";